import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "How can I celebrate my birthday with a food donation through Sood Charity Foundation?",
    answer: "You can celebrate your birthday meaningfully by choosing to donate food on your birthday via Sood Charity Foundation. Simply visit our donation page, select the \"birthday food donation\" option, and we'll take care of distributing meals to those in need. It's one of the best ways to celebrate a birthday—with love and purpose."
  },
  {
    question: "Is it possible to enjoy a birthday party and still make a birthday celebration donation?",
    answer: "Absolutely! You can plan your birthday party and still make a birthday celebration donation. Whether it's setting aside a portion of your budget or asking guests to donate on your birthday instead of giving gifts, it's a beautiful balance of celebration and charity."
  },
  {
    question: "What are some meaningful things to do for a birthday apart from parties?",
    answer: "Some thoughtful things to do for your birthday include: Donating food on birthday to those in need, Supporting children's education through a birthday charity, Organizing a birthday food donation drive. These ideas turn your day into a noble cause and create lasting impact."
  },
  {
    question: "How does my food donation on birthday reach the beneficiaries?",
    answer: "When you donate food on birthday through Sood Charity Foundation, we ensure your donation is used to prepare and distribute meals through verified kitchens and local partners. You'll also receive updates and photos of how your birthday food donation made an impact."
  },
  {
    question: "Do I get a tax benefit if I donate on my birthday?",
    answer: "Yes! All donations made to Sood Charity Foundation, including birthday celebration donations, are eligible for tax benefits under Section 80G of the Income Tax Act. It's a smart and compassionate way to celebrate your birthday—combining joy, charity, and savings."
  }
];

function FAQItem({ faq, isOpen, onClick }) {
  return (
    <div className={`faq-item ${isOpen ? 'faq-item-open' : ''}`}>
      <button
        className="faq-question"
        onClick={onClick}
      >
        <span>{faq.question}</span>
        <ChevronDown className={`faq-icon ${isOpen ? 'faq-icon-open' : ''}`} />
      </button>
      <div className={`faq-answer-wrapper ${isOpen ? 'faq-answer-open' : ''}`}>
        <div className="faq-answer">
          {faq.answer}
        </div>
      </div>
    </div>
  );
}

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              faq={faq}
              isOpen={index === openIndex}
              onClick={() => toggleIndex(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQSection;
